export default __webpack_public_path__ + "static/media/2fB.18579872.png";